module.exports = __webpack_public_path__ + "img/ring_r_skip_null_null.b44f3d5d.png";